import React from 'react';
import { Box, costFormater, Text } from '@common-fe/common-fe';
import _ from 'lodash';

import theme from '@/styles/theme';

interface ChartListItem {
  id: string;
  color: string;
  title: string;
  percentage: number;
  value: number;
}
interface Props {
  testId: string;
  items: ChartListItem[];
}
const ChartDescriptionItems: React.FC<Props> = ({ items, testId = '' }) => {
  if (!items?.length) {
    return (
      <Box fill justify="center" data-testId={`${testId}-wrapper`}>
        <Text color="textDisabled" size="small" weight={500}>
          No claims processed yet
        </Text>
      </Box>
    );
  }
  return (
    <Box direction="row" data-testId={`${testId}-wrapper`}>
      <Box direction="column" fill gap="spacing8">
        {items.map((item, index) => (
          <Box key={`${testId}_item_${index}_title`} direction="row" align="center" justify="start">
            <Box
              width="8px"
              height="8px"
              round="smallRound"
              background={item.color || theme.colors.iconDisabled}
              flex={false}
              margin={{ right: 'spacing4' }}
            />
            <Text size="medium" truncate>
              {item.title}
            </Text>
          </Box>
        ))}
      </Box>
      <div>
        <Box direction="column" gap="spacing8" margin={{ right: 'spacing8' }}>
          {items.map((item, index) => (
            <Box key={`${testId}_item_${index}_percents`} direction="row" align="center">
              <Text size="medium" weight={400}>
                {`${_.round(item.percentage, 2)}%`}
              </Text>
            </Box>
          ))}
        </Box>
      </div>
      <div>
        <Box direction="column" gap="spacing8">
          {items.map((item, index) => (
            <Box
              key={`${testId}_item_${index}_value`}
              //   width={{ min: '100px' }}
              direction="row"
              pad={{ left: 'spacing8' }}
              align="center"
              justify="end"
            >
              <Text size="medium" weight={600}>
                {costFormater(item.value, { isPrecision: true })}
              </Text>
            </Box>
          ))}
        </Box>
      </div>
    </Box>
  );
};

export default ChartDescriptionItems;
